var _g, _path, _g2, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSaveIcon = function SvgSaveIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Asset / Empty / Pembahasan"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE4\xBF\xA1\xE6\x81\xAF"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 653",
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "url(#paint0_linear_1119_141197)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\xE5\x86\x85\xE5\xAE\xB9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1119_141197",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 150,
    height: 150
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 654",
    d: "M75 150C116.421 150 150 116.421 150 75C150 33.5786 116.421 0 75 0C33.5786 0 0 33.5786 0 75C0 116.421 33.5786 150 75 150Z",
    fill: "url(#paint1_linear_1119_141197)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1119_141197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M119.566 59H32.4332C31.2576 59.0007 30.1305 59.469 29.2993 60.302C28.468 61.135 28.0007 62.2645 28 63.4426V143.557C28.0007 144.735 28.468 145.865 29.2993 146.698C30.1305 147.531 31.2576 147.999 32.4332 148H119.566C120.742 147.999 121.869 147.531 122.701 146.698C123.532 145.865 123.999 144.736 124 143.557V63.4426C123.999 62.2645 123.532 61.1348 122.701 60.3018C121.869 59.4688 120.742 59.0006 119.566 59Z",
    fill: "url(#paint2_linear_1119_141197)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/receive-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "receive-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M58.3359 51.293L75.0026 67.9596L91.6693 51.293",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M75.002 67.9601V23.5156",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M41.668 76.0664C63.2791 83.2886 86.7235 83.2886 108.335 76.0664",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M129.955 100.425L123.814 144.186C123.507 146.374 121.646 148 119.451 148H31.7062C29.5113 148 27.6511 146.374 27.344 144.186L19.0441 85.0546C18.6697 82.3851 20.7277 80 23.4063 80H50.5038C52.6988 80 54.559 81.6259 54.866 83.8133L55.9537 91.557C56.2608 93.7448 58.121 95.3707 60.3159 95.3707H125.594C128.272 95.3707 130.33 97.7559 129.956 100.425H129.955Z",
    fill: "url(#paint3_linear_1119_141197)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M108.676 129H42.3239C41.9603 129 41.6091 128.875 41.3363 128.649C41.0634 128.422 40.8876 128.11 40.8418 127.77L40.0116 121.582C39.9852 121.384 40.0039 121.183 40.0663 120.993C40.1287 120.802 40.2335 120.626 40.3736 120.476C40.5138 120.327 40.6862 120.207 40.8793 120.125C41.0724 120.043 41.2819 120 41.4938 120H109.506C109.718 120 109.928 120.043 110.121 120.125C110.314 120.207 110.486 120.327 110.626 120.476C110.767 120.626 110.871 120.802 110.934 120.993C110.996 121.183 111.015 121.384 110.988 121.582L110.158 127.77C110.112 128.11 109.937 128.422 109.664 128.649C109.391 128.875 109.04 129 108.676 129Z",
    fill: "#C2EDFF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1119_141197",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 191.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6CFE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1119_141197",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBE1FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5CBD6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1119_141197",
    x1: 76,
    y1: 59,
    x2: 76.2548,
    y2: 119.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9AC5D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#739FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1119_141197",
    x1: 23.5492,
    y1: 118.135,
    x2: 130,
    y2: 118.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABCAD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193638,
    stopColor: "#BED6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#C4DDE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72836,
    stopColor: "#BED6E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.927,
    stopColor: "#ABCAD8"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSaveIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/save-icon.5868f996.svg";
export { ForwardRef as ReactComponent };